import { useContext } from "react";

import { TranslateContext } from "@/providers/TranslateProvider";

export const useTranslate = () => {
  const context = useContext(TranslateContext);
  if (context === undefined) {
    throw new Error("useTranslate must be used within TranslateProvider");
  }
  return context;
};
